"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _resolver, _rejecter, _promise, _isCompleted, _result, _isResolved;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletablePromise = void 0;
/**
 * The Promise that could explicitly be resolved or rejected by calling
 * its methods. Could be used as a regular promise.
 *
 * Note that "modified" system promise under V8 was once found much less effective than unaltered
 * promise. While We hope it is already fixed, it could still be a bottleneck.
 */
class CompletablePromise {
    constructor() {
        _resolver.set(this, void 0);
        _rejecter.set(this, void 0);
        _promise.set(this, void 0);
        _isCompleted.set(this, false);
        _result.set(this, void 0);
        _isResolved.set(this, false);
        this[Symbol.toStringTag] = "CompletablePromise";
        __classPrivateFieldSet(this, _promise, new Promise((resolve, reject) => {
            __classPrivateFieldSet(this, _resolver, resolve);
            __classPrivateFieldSet(this, _rejecter, reject);
        }));
    }
    finally(onFinally) {
        return __classPrivateFieldGet(this, _promise).finally(onFinally);
    }
    /**
     * Set promise to resolved state.
     * @param result
     * @throws Error if already completed
     */
    resolve(result) {
        if (__classPrivateFieldGet(this, _isCompleted))
            throw "already completed";
        __classPrivateFieldSet(this, _isCompleted, true);
        __classPrivateFieldSet(this, _result, result);
        __classPrivateFieldSet(this, _isResolved, true);
        __classPrivateFieldGet(this, _resolver).call(this, result);
    }
    /**
     * Set promise to rejected state.
     * @param result
     * @throws Error if already completed
     */
    reject(error) {
        if (__classPrivateFieldGet(this, _isCompleted))
            throw "already completed";
        __classPrivateFieldSet(this, _isCompleted, true);
        __classPrivateFieldGet(this, _rejecter).call(this, error);
    }
    catch(onRejected) {
        return __classPrivateFieldGet(this, _promise).catch(onRejected);
    }
    then(onfulfilled, onRejected) {
        return __classPrivateFieldGet(this, _promise).then(onfulfilled);
    }
    get isCompleted() { return __classPrivateFieldGet(this, _isCompleted); }
    /**
     * For the completed promise, return its result. Throws error if it is not completed or was rejected,
     * so check it state first.
     */
    get result() {
        if (!__classPrivateFieldGet(this, _isResolved))
            throw "promise rejected";
        if (!__classPrivateFieldGet(this, _isCompleted) || !__classPrivateFieldGet(this, _result))
            throw "not completed";
        return __classPrivateFieldGet(this, _result);
    }
    /**
     * returns true if the promise is resolved. False if it is rejected.
     */
    get isResolved() {
        if (!__classPrivateFieldGet(this, _isCompleted))
            return false;
        return __classPrivateFieldGet(this, _isResolved);
    }
    /**
     * returns true if this promise was rejected.
     */
    get isRejected() {
        if (!__classPrivateFieldGet(this, _isCompleted))
            return false;
        return !__classPrivateFieldGet(this, _isResolved);
    }
}
exports.CompletablePromise = CompletablePromise;
_resolver = new WeakMap(), _rejecter = new WeakMap(), _promise = new WeakMap(), _isCompleted = new WeakMap(), _result = new WeakMap(), _isResolved = new WeakMap();
//# sourceMappingURL=CompletablePromise.js.map